<template>
  <div
    class="langs_div_class"
    v-if="enabled"
    :class="[
      vogue_select_class,
      { vogueLangs: theme == 'vogue' || theme == 'athena' },
      { normal_select: select_model == 'normal_select' },
    ]"
    :style="langs_props"
  >
    <i
      class="iconfont icon-diqiu"
      v-if="has_icon && select_model == 'normal_select'"
      :style="{ color: text_color }"
    ></i>
    <select
      v-if="select_model == 'normal_select' || (theme !== 'vogue' && theme !== 'athena')"
      id="select_lang"
      v-model="selected"
      name="select_lang"
      class="langs_select_class page_text_font"
      :style="{ color: text_color }"
    >
      <option class="page_text_font" v-for="(lang, index) in languages_options" :value="lang" :key="index">
        {{ translate(lang) }}
      </option>
    </select>
    <div v-else>
      <span class="vogue_select_lang menu_icon_color secondary_title">
        <i class="iconfont icon-diqiu" v-if="has_icon"></i>
        {{ translate($i18n.locale) }}
      </span>
      <v-popbox :style="{ padding: 0 }" parentEl="langs_div_class" elId="lang" :appendToBody="appendToBody">
        <div
          class="lang__item"
          :style="{ 'border-top': '12px solid ' + back_color + '!important' }"
          v-if="theme == 'vogue' && (langs_style !== 'custom' || custom_config.length)"
        ></div>
        <ul class="lang_options" v-if="langs_style == 'custom' && custom_config.length">
          <li v-for="(item, index) in custom_config" :key="item.url + index" class="vogue_menu_icon_color" :style="{'background-color': back_color,}">
            <a :href="item.url">
              {{ item.name }}
            </a>
          </li>
        </ul>
        <ul class="lang_options" v-if="langs_style != 'custom'">
          <li
            v-for="lang in languages_options"
            @click="selected = lang"
            :key="lang"
            class="vogue_menu_icon_color menu_icon_color"
            :style="{
              fontWeight: selected == lang ? '600' : '',
              'background-color': back_color,
            }"
          >
            {{ translate(lang) }}
          </li>
        </ul>
      </v-popbox>
    </div>
  </div>
</template>
<script>
import { loadLanguageAsync } from '@/locales/index'
import vPopbox from "@/js/components/common/popBox.vue";
import { mapState } from 'vuex';
export default {
  props: {
    langs_meta: {},
    vogue_select_class: {},
    appendToBody: {},
    has_icon: {},
    select_model: {}, //默认选择器 一般用于页脚,
    langs_props: {},
    text_color: {}, //文本颜色
  },
  data() {
    return {
      selected: '',
      languages_options: [],
    }
  },
  computed: {
    ...mapState({
      back_color: ({ options }) => options.theme?.modules?.header?.menu_background_color,
      langs: ({ options }) => options.theme?.global?.language || {},
      theme: ({ theme_name }) => theme_name
    }),
    enabled() {
      return this.langs?.enabled || false
    },
    // 自定义
    custom_config() {
      const { langs_style, custom_config } = this.langs

      let arr = []
      if (langs_style == 'custom' && custom_config?.length) {
        custom_config.forEach(item => {
          if (item.name && item.url) {
            arr.push(item)
          }
        })  
      }
      return arr
    },
    langs_style() {
      return this.langs?.langs_style
    }
  },
  beforeMount() {
    this.bus.$on('change_lang', (lang) => {
      if (this.selected != lang) {
        this.selected = lang
      }
    })
  },
  mounted() {
    let default_lang = localStorage.getItem(this.theme + '_default_lang')
    let theme_locale = localStorage.getItem(this.theme + '_locale')
    let { default_language, select_languages, all_language } = this.langs
    localStorage.setItem(this.theme + '_default_lang', default_language || 'English')
    if (select_languages && this.langs_meta.options_languages) {
      this.languages_options = all_language ? this.langs_meta.options_languages : select_languages
    }
    if (
      (!this.enabled && default_language) ||
      (theme_locale == default_lang && default_language && default_lang != default_language)
    ) {
      localStorage.setItem(this.theme + '_default_lang', default_language)
      //不开启语言选择器时，或者用户使用语言等于当前语言时候使用默认语言
      this.selected = default_language
      localStorage.setItem(this.theme + '_locale', default_language)
    } else if (default_language) {
      //判断已选语言是否包含缓存在localStorage里的语言
      localStorage.setItem(this.theme + '_default_lang', default_language)
      let flag = this.languages_options.includes(theme_locale)
      if (flag) {
        //开启语言选择器时,先使用localStorage缓存的语言选项(如有),否则使用默认语言
        this.selected = theme_locale || default_language
      } else {
        //如果已选语言不包含缓存在localStorage里的语言
        this.selected = default_language
        // localStorage.setItem(this.theme+"_locale", this.langs.default_language);
      }
    } else {
      this.selected = 'English'
      localStorage.removeItem('locale')
      localStorage.removeItem(this.theme + '_locale')
    }
  },
  watch: {
    // langs: {
    //   handler(newV) {
    //     if (!newV) return
    //     let { langs_style, custom_config } = newV
    //     this.langs_style = langs_style
    //     if (langs_style == 'custom' && custom_config && custom_config.length) {
    //       this.custom_config = custom_config
    //     }
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    selected(val, oldval) {
      if (val != oldval) {
        loadLanguageAsync(val)
        localStorage.setItem(this.theme + '_locale', val) //允许切换主题时使用不一致的语言
        // localStorage.setItem("locale", val);//app.js初始化时使用，避免在venue设置了语言，到结账页面不生效
        this.bus.$emit('change_lang', val)
      }
    },
  },
  methods: {
    translate(lang = 'English') {
      let res = null
      switch (lang.toLocaleLowerCase()) {
        case 'english':
          res = 'English'
          break
        case 'chinese':
          res = '简体中文'
          break
        case 'spanish':
          res = 'Español'
          break
        case 'french':
          res = 'Français'
          break
        case 'german':
          res = 'Deutsche'
          break
        case 'portuguese':
          res = 'Português'
          break
        case 'italian':
          res = 'Italiano'
          break
        case 'japanese':
          res = '日本語'
          break
        case 'russian':
          res = 'русский'
          break
        case 'dutch':
          res = 'Nederlands'
          break
        case 'korean':
          res = '한국어'
          break
        default:
          res = lang
          break
      }
      return res
    },
  },
  components: {
    vPopbox,
  }
}
</script>
<style scoped lang="scss">
.langs_div_class {
  height: 25px;
  margin-top: 5px;
  margin-bottom: 5px;
  position: relative;

  .langs_select_class {
    // margin: auto;
    width: 100px;
    color: #989191;
    border: 1px solid #f1f1f0;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    option {
      color: black;
    }
  }
}
.normal_select {
  .icon-diqiu {
    font-size: 18px;
    line-height: 20px;
  }
  #select_lang {
    padding: 0 !important;
    border: none !important;
    background: transparent;
    vertical-align: bottom;
    text-decoration: underline;
    appearance: none;
    color: #222a40;
    font-size: 16px;
    line-height: 20px;
  }
}
.vogueLangs {
  display: inline-block;
  line-height: 1;
  margin-top: 0;
  margin-bottom: 0;
  cursor: pointer;
  .lang__item {
    position: absolute;
    top: -11px;
    z-index: 1000000;
    left: 30px;
    content: '';
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #fff;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));
    transform: rotate(180deg);
  }
  #select_lang {
    padding: 0 15px;
  }
  .vogue_select_lang {
    display: flex;
    align-items: center;
    line-height: 22px;
    .icon-diqiu {
      font-size: 23px;
      margin-right: 12px;
    }
  }
}
.moda_left_langs {
  line-height: 1.8;
}

.lang_options {
  li {
    display: block;
    min-width: 170px;
    line-height: 20px;
    padding: 8px 15px;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .langs_select_class {
    margin: auto;
  }
}
</style>
